<template>
  <div class="home">
    <div>
      <div class="nav-header">
        <NavHeader ref="navheader" @navLeftClick="navLeftClick" @navRightClick="navRightClick" @selectEmaByType="resetGetList" :windowWidth="windowWidth" @searchEmail="goto" />
        <div :class="windowWidth < 677 ? 'home-search' : 'new-home-search' ">
          <span @click="handelShow"><img src="../../assets/img/drawer_mai.png" alt="" /></span>
          <div class="read-filter">
            <span :class="isRead === i.val && 'cur-item'" v-for="i in readFilterOptions" :key="i.val" @click.stop="changeIsRead(i.val)">{{i.title}}</span>
          </div>
        </div>
      </div>

      <div :class="windowWidth < 677 ? 'home-list' : 'new-home-list'" v-if="list.length">
        <div v-if="language!=='origin'" class="translateTip"><van-icon class="warning-icon" name="warning" />{{$t('translate.translateTip')}}</div>

        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" :finished-text="$t('home.end')" @load="onLoad">
            <div v-if="windowWidth < 677">
              <ListItem v-for="(item, i) in list" @clickEmaItem="clickEmaItem" :isMulti="isSelectEma" :FolderType="ListInfo.seachForm.FolderType" :item="item" :key="item.Id + i" />
            </div>
            <div v-else>
              <NewListItem v-for="(item, i) in list" @clickEmaItem="clickEmaItem" :isMulti="isSelectEma" :FolderType="ListInfo.seachForm.FolderType" :item="item" :key="item.Id + i" :windowWidth="windowWidth" />
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <div class="home-list" v-else>
        <NoData />
      </div>
    </div>
    <!-- <SelectEma
			:list="$store.state.List.selectEmaList"
			:FolderType="ListInfo.seachForm.FolderType"
			@btnClick="btnClick"
			@rightClick="rightClick"
			v-show="showSelect" /> -->
    <!-- 侧边栏弹出框 -->
    <van-popup open="onOpen" @click-overlay="closeOverlay" v-model="isShow" position="left" :style="{ height: '100vh', width: '80%' }">
      <Sidebar v-if="isShow" :list="sidebarList" @handelClose="close" :pid="pid" />
    </van-popup>
    <div :class="windowWidth < 677 ? 'home-jump iconfont icon-edit' : 'new-home-jump iconfont icon-edit' " @click="jupToWrit"></div>
  </div>
</template>

<script>
import ListItem from '@/components/listItem'
import NewListItem from '@/components/newListItem'
import NavHeader from '@/components/navHeader'
import Sidebar from './components/Sidebar.vue'
// import SelectEma from '@/components/SelectEma'
import NoData from '@/components/noData'
import translateMixin from '@/components/translate/index.js'
export default {
	name: 'Home',
	components: {
		ListItem,
		NewListItem,
		NavHeader,
		Sidebar,
		// SelectEma,
		NoData
	},
	mixins: [translateMixin],
	data() {
		return {
			// showSelect: false,
			loading: false,
			isShow: false,
			finished: false,
			refreshing: false,
			isSelectEma: false, //选择邮件
			windowWidth: document.documentElement.clientWidth,
			seachForm: {
				page: 0,
				rows: 20,
				sidx: '',
				sord: 'desc',
				queryData: {}
			},
			list: [],
			sidebarList: [], // 侧边栏数据
			pid: '',
			listId: [],
			// 是否已读 为空:全部 'true':已读邮件 'false':全部邮件
			isRead: ''
		}
	},
	watch: {
		windowWidth(val) {
			let that = this
			console.log('实时屏幕宽度：', val, that.windowWidth)
		},
		language() {
			window.scrollTo(0, 0)
			this.refreshing = true
			this.onLoad()
		}
	},
	computed: {
		ListInfo() {
			return this.$store.state.List
		},
		readFilterOptions() {
			return [
				{
					title: this.$t('isRead.all'),
					val: ''
				},
				{
					title: this.$t('isRead.read'),
					val: 'true'
				},
				{
					title: this.$t('isRead.unread'),
					val: 'false'
				}
			]
		}
	},
	mounted() {
		var that = this
		// <!--把window.onresize事件挂在到mounted函数上-->
		window.onresize = () => {
			return (() => {
				window.fullWidth = document.documentElement.clientWidth
				that.windowWidth = window.fullWidth // 宽
			})()
		}
		this.$bus.$on('needRefreshEmailList', (item) => {
			console.log('监听列表页面刷新', item)
			if (!item) return
			console.log('重新加载')
			setTimeout(() => {
				this.resetGetList()
			}, 500)
			// toast.clear()
		})
	},
	activated() {
		this.headerChange()
		this.$nextTick(() => {
			this.$refs['navheader'].defaultStatus()
		})
	},
	created() {
		let toAdd = localStorage.getItem('ToAdd')
		let toName = localStorage.getItem('ToName')
		let toEmail = localStorage.getItem('ToEmail')
		if (toAdd == 1) {
			localStorage.setItem('ToAdd', 0)
			this.jupToWrit()
		}

		this.getUserList()
		this.onLoad()
		this.$bus.$on('closeDialogue', (item) => {
			this.close(item)
		})
	},
	methods: {
		selectEnterpriseContact() {
			selectEnterpriseContact()
		},
		/* 点击邮件 改变邮件已读状态 */
		clickEmaItem(item) {
			const arr = [...this.list]
			if (arr.length) {
				let num = 0
				arr.map((e, i) => {
					if (item.Id === e.Id) {
						num = i
					}
				})
				arr.splice(num, 1, item)
				this.list = arr
				this.headerChange()
			}
		},
		/* 取消隐藏 */
		rightClick() {
			// this.showSelect = false
		},
		/* 操作 */
		btnClick() {
			// this.showSelect = false
			this.headerChange()
			this.resetGetList()
		},
		/* 改变头部信息 */
		headerChange() {
			this.$refs['navheader'].getNotReadNumber({
				ParentFolderId: this.ListInfo.seachForm.ParentFolderId,
				DisplayName: this.ListInfo.DisplayName
			})
		},
		/* 点击头部左边按钮 */
		navLeftClick() {},
		async getUserList() {
			const res = await this.$api.getFolderList()
			this.sidebarList = res.Data
			for (let index = 0; index < res.Data.length; index++) {
				this.listId.push(res.Data[index].Id)
			}
			this.pid = res.Data[1].ParentFolderId
		},
		/* 右侧点击关闭 */
		close(val) {
			console.log('close')
			if (!val) return
			this.isShow = false

			this.finished = false
			this.loading = true
			window.scrollTo(0, 0)
			this.$nextTick(() => {
				this.resetGetList()
			})

			let obj = { ...this.ListInfo.seachForm }
			obj.ParentFolderId = val.Id
			obj.FolderType = val.FolderType
			// this.
			// console.log('点击左侧菜单栏----', val)
			this.$store.commit('setSeachForm', obj)
			this.$store.commit('setDisplayName', val.DisplayName)
			if (val.FolderType == 1) {
				this.$store.commit('setSeachId', this.listId[0])
			} else if (val.FolderType == 2) {
				this.$store.commit('setSeachId', this.listId[1])
			} else if (val.FolderType == 3) {
				this.$store.commit('setSeachId', this.listId[2])
			} else if (val.FolderType == 4) {
				this.$store.commit('setSeachId', this.listId[3])
			} else if (val.FolderType == 5) {
				this.$store.commit('setSeachId', this.listId[4])
			}

			this.$nextTick(() => {
				this.$refs['navheader'].getNotReadNumber(val)
			})
		},
		/* 点击头部右侧按钮 */
		navRightClick(e) {
			if (e.itemKey === 'select') {
				this.isSelectEma = true
				this.$store.commit('setSelectEmaList', [...this.list])
				// this.showSelect = true
				this.$router.push('/select')
			} else {
				// const IdList = this.list.map((item) => item.Id)
				this.tagNoRead()
			}
		},
		/* 标记为已读读*/
		tagNoRead() {
			const toast = this.$toast.loading({
				duration: 0,
				message: this.$t('home.success'),
				forbidClick: true
			})
			this.$api
				.changeStatusByFolderId({
					SetUnRead: false,
					FolderId: this.ListInfo.seachForm.ParentFolderId
				})
				.then((result) => {
					toast.clear()
					this.$toast.success({
						duration: 1000,
						message: this.$t('home.success')
					})
					this.resetGetList()
					this.headerChange()
				})
		},
		/* 重新加载 */
		async resetGetList() {
			console.log('resetGetList')
			this.refreshing = true
			this.headerChange()
			this.onLoad()
		},
		/* 下拉加载更多 */
		onRefresh() {
			// 清空列表数据
			this.finished = false
			// this.refreshing = true
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true
			this.headerChange()
			this.onLoad()
		},
		/*列表加载数据*/
		onLoad() {
			/* 加载数据 */
			this.seachForm.page++
			let obj = { ...this.seachForm }
			obj.queryData = { ...this.ListInfo.seachForm, IsRead: this.isRead }
			if (this.refreshing) {
				obj.page = 1
				this.seachForm.page = 1
			}
			console.log('onLoad')
			this.$api
				.getEmaList(obj)
				.then((res) => {
					if (res.Code === 0) {
						if (this.refreshing) {
							this.refreshing = false
							this.list = []
						}
						const { Data } = res
						this.loading = false
						this.list = this.list.concat(Data.rows)
						if (this.language !== 'origin') {
							this.startTranslate()
						}

						// console.log(this.list)
						/* 所有数据加载完成 */
						if (this.list.length === Data.records || !Data.rows.length) {
							this.finished = true
						}
					} else {
						this.loading = false
						this.finished = true
					}
				})
				.catch(() => {
					this.loading = false
					this.refreshing = false
					this.finished = true
				})
		},

		// 翻译邮件列表数据
		startTranslate() {
			if (!this.list.length) {
				return
			}
			// 保存默认数据
			this.list.forEach((item) => {
				if (!item.__defaultData) {
					item.__defaultData = {
						sender: item.Sender.Name,
						subject: item.Subject,
						preview: item.Preview
					}
				}
			})

			// 需要翻译的数据
			let arr = {
				sender: [],
				subject: [],
				preview: []
			}

			let key = this.language === 'en' ? '__englishData' : '__chineseData'

			this.list.forEach((item) => {
				if (!item[key]) {
					let itemData = item.__defaultData
					// 预览内容截取100个字符，并去除空格和换行符等
					let preview = itemData.preview.substr(0, 50)
					preview = preview.replace(/\n|\r|&amp;|&lt;|&gt;|&quot;/g, '')
					arr.sender.push(itemData.sender.replace(/\n|\r/g, '') || '无发件人')
					arr.subject.push(itemData.subject.replace(/\n|\r/g, '') || '无主题')
					arr.preview.push(preview || '无内容')
				} else {
					item.Sender.Name = item[key].sender
					item.Subject = item[key].subject
					item.Preview = item[key].preview
				}
			})

			let needTrasArr = [...arr.sender, ...arr.subject, ...arr.preview]
			if (needTrasArr.length) {
				this.translateText(this.language, needTrasArr, this.setTranslatedList)
			}
		},

		setTranslatedList(data) {
			let key = this.language === 'en' ? '__englishData' : '__chineseData'
			let index = 0
			this.list.forEach((item) => {
				if (!item[key]) {
					const sender = data[index]
					const subject = data[index + data.length / 3]
					const preview = data[index + (data.length / 3) * 2]
					item.Sender.Name = sender
					item.Subject = subject
					item.Preview = preview
					item[key] = {
						sender,
						subject,
						preview
					}
					index++
				}
			})
		},

		/* 点击跳转写邮件 */
		jupToWrit() {
			this.$router.push({
				path: '/writemail',
				query: {
					ftype: this.ListInfo.seachForm.FolderType
				}
			})
		},
		// 点击展示侧边栏
		async handelShow() {
			// this.isShow = true
			await this.getUserList()
			this.isShow = !this.isShow
		},
		closeOverlay() {
			this.isShow = !this.isShow
		},
		goto() {
			this.$router.push('/search')
			this.$bus.$emit('changeShow', true)
		},
		changeIsRead(val) {
			if (val === this.isRead) return
			this.isRead = val
			this.finished = false
			this.loading = true
			window.scrollTo(0, 0)
			this.resetGetList()
		}
	}
}
</script>
<style lang="less" scoped>
.showSelect {
	height: 100vh;
	overflow: hidden;
}
.home {
	position: relative;
	.read-filter {
		background: #f1f1f1;
		padding: 2px;
		font-size: 12px;
		border-radius: 2px;
		span {
			display: inline-block;
			cursor: pointer;
			color: #505455;
			border-radius: 2px;
			padding: 0 12px;
			line-height: 24px;
		}
		.cur-item {
			background: #fff;
			color: #015de5;
		}
	}
	.home-list {
		margin-top: 110px;
	}
	.new-home-list {
		margin-top: 70px;
	}
	.nav-header {
		position: fixed;
		width: 100%;
		top: 0;
		background: #fff;
		z-index: 2000;
		.home-search {
			box-sizing: border-box;
			width: 100%;
			height: 56px;
			top: 50px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 16px;
			.seach-input {
				flex: 1;
				position: relative;
				img {
					position: absolute;
					top: 11px;
					left: 12px;
					width: 14px;
					height: 14px;
				}
				input {
					width: 90%;
					height: 36px;
					border-radius: 4px;
					border: none;
					background: #f2f3f5;
					padding-left: 34px;
				}
			}
			img {
				width: 20px;
				height: 20px;
				margin-right: 16px;
			}
		}
		.new-home-search {
			box-sizing: border-box;
			width: 100%;
			height: 28px;
			top: 25px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 8px;
			.seach-input {
				flex: 1;
				position: relative;
				img {
					position: absolute;
					top: 6.5px;
					left: 6px;
					width: 7px;
					height: 7px;
				}
				input {
					width: 90%;
					height: 18px;
					border-radius: 2px;
					border: none;
					background: #f2f3f5;
					padding-left: 17px;
					font-size: 7px;
				}
			}
			img {
				width: 10px;
				height: 10px;
				margin-right: 8px;
			}
		}
	}
	.home-jump {
		width: 48px;
		height: 48px;
		background: #005de5;
		position: fixed;
		bottom: 100px;
		right: 24px;
		z-index: 2004;
		border-radius: 100%;
		line-height: 48px;
		color: #fff;
		text-align: center;
		font-size: 24px;
	}
	.new-home-jump {
		width: 24px;
		height: 24px;
		background: #005de5;
		position: fixed;
		bottom: 50px;
		right: 12px;
		z-index: 2004;
		border-radius: 100%;
		line-height: 24px;
		color: #fff;
		text-align: center;
		font-size: 12px;
	}
	.drop-title {
		text-align: center;
	}
	.translateTip {
		font-size: 12px;
		color: #f2a242;
		background: #fef9eb;
		padding: 8px 12px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		.warning-icon {
			font-size: 16px;
			margin: -1px 4px 0 0;
		}
	}
}
</style>
